import { ROUTE_NAME } from '@constants';

const isMobile = /mobile/i.test(navigator.userAgent);

const clubIntroduction = {
  path: '/club-introduction',
  redirect: '/club-introduction/introduction',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '클럽소개',
    navMenu: true,
    description: '고객 여러분을 위해 보다 나은 서비스를 제공하겠습니다.',
  },
  name: ROUTE_NAME.Introduction,
  children: [
    {
      name: ROUTE_NAME.Introduction,
      path: 'introduction',
      component: () => import('@views/club-introduction/Introduction.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: isMobile ? '인사말' : '인사말',
        mobileVisible: true,
      },
    },
    {
      name: ROUTE_NAME.Overview,
      path: 'overview',
      component: () => import('@views/club-introduction/Overview.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '개요',
      },
    },
    {
      name: ROUTE_NAME.Location,
      path: 'location',
      component: () => import('@views/club-introduction/Location.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '오시는길',
      },
    },

    {
      name: ROUTE_NAME.GolfClubNetwork,
      path: 'golf-club-network',
      component: () => import('@views/club-introduction/GolfClubNetwork.vue'),
      meta: {
        isReady: false,
        breadcrumb: false,
        breadcrumbName: '자매골프클럽',
      },
    },
    {
      name: ROUTE_NAME.InteractionClub,
      path: 'interaction-club',
      component: () => import('@views/club-introduction/InteractionClub.vue'),
      meta: {
        isReady: false,
        breadcrumb: true,
        breadcrumbName: '상호교류클럽',
      },
    },
  ],
};

export default clubIntroduction;
